<template>
    <div>
        <v-layout justify-space-between align-center mb-4>
            <v-btn v-if="common.hasPermissions('roles', ['create'])" round color="primary" @click="addRole">Add Role</v-btn>
           
        </v-layout>
        <v-dialog v-model="dialog" width="600">
            <editDialog
                :action="currentAction"
                :data="currentRole"
                @close="dialog = false"
            ></editDialog>
        </v-dialog>
        <v-dialog v-model="deleteDialog" width="500">
            <delete-dialog v-if="currentRole"
                :title="`${currentRole.name}`"
                @onDelete="deleteRole(currentRole.id)"
            ></delete-dialog>
        </v-dialog>
        <v-card  class="rounded-box" flat>
            <v-card-title class="pt-0">
                Roles
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    class="ma-0 pa-0"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="roles" :search="search">
        <template v-slot:items="{ item }">
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
                <v-layout row wrap justify-center v-if="![1,2,3].includes(item.id) && (common.hasPermissions('roles', ['update']) || common.hasPermissions('roles', ['delete']))">
                    <v-icon v-if="common.hasPermissions('roles', ['update'])" small class="mr-2" @click="editRole(item)">mdi-pencil</v-icon>
                    <v-icon v-if="common.hasPermissions('roles', ['delete'])" small @click="openDeleteDialog(item)">mdi-delete</v-icon>
                </v-layout>
            </td>
        </template>
        </v-data-table>
        </v-card>
    </div>

</template>
<script>
import common from "../../utils/common";
import deleteDialog from "../common/deleteDialog";
import editDialog from "./rolesAddOrEdit";

export default {
    components: {
        deleteDialog,
        editDialog
    },
    data() {
        return {
            common,
            search: '',
            headers: [
                { text: 'Name', value: 'name' },
                { text: 'Description', value: 'description' },
                { text: 'Actions', value: 'actions', sortable: false }
            ],
            dialog: false,
            deleteDialog: false,
            currentRole: {},
            currentAction: 'add',
        }
    },
    mounted() {
        this.$store.dispatch('fetchRoles')
    },
    computed: {
        roles() {
            return this.$store.state.user.roles;
        }
    },
    methods: {
        addRole() {
            this.currentAction = 'add'
            this.currentRole = {
                name: "",
                description: "",
                permissions: {},
            }
            this.dialog = true
        },
        editRole(role) {
            this.currentAction = 'edit'
            this.currentRole = role
            this.dialog = true
        },
        openDeleteDialog(role) {
            this.currentRole = role
            this.deleteDialog = true
        },
        deleteRole(id) {
            this.$http.delete(`/roles/${id}`).then(() => {
                this.$store.dispatch('fetchRoles', true)
                this.deleteDialog = false
                this.currentRole = {}
            });
        }
    }

}

</script>